import React, { useState } from 'react';
import { Link } from 'gatsby';
import styles from './Button.module.scss';
import classNames from 'classnames';
import icons from './icons';

export default function Button({
  theme,
  color,
  hoverColor,
  fontSize,
  className,
  style = {},
  size,
  icon,
  to,
  href,
  iconClassName,
  iconStyle,
  children,
  onClick,
  ...restProps
}) {
  const [isHovered, setIsHovered] = useState(false);

  const props = {
    to,
    href,
    className: classNames('button', styles.button, className, {
      [styles.white]: theme === 'white',
      [styles.small]: size === 'small'
    }),
    style: {
      fontSize,
      color: isHovered && hoverColor ? hoverColor : color,
      ...style
    },
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    onClick: e => {
      if (!to && !href) {
        e.stopPropagation();
        e.preventDefault();
        document.activeElement?.blur();
      }

      if (onClick) {
        onClick(e);
      }
    },
    onKeyDown: e => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        document.activeElement?.blur();
      }
    },
    ...restProps
  };

  const Icon = icons[icon];
  const content = (
    <React.Fragment>
      {Icon && (
        <Icon
          className={classNames(styles.icon, icon, iconClassName)}
          style={iconStyle}
        />
      )}
      <span>{children}</span>
    </React.Fragment>
  );

  const Tag = props.href ? 'a' : 'button';

  return props.to ? (
    <Link {...props}>{content}</Link>
  ) : (
    <Tag {...props}>{content}</Tag>
  );
}

export function ButtonsWrapper({ className, children }) {
  return (
    <div className={classNames(styles.buttonsWrapper, className)}>
      {children}
    </div>
  );
}
